const DateUtils = {
    getDateInISTFormat : (dateString) => {
        const date = new Date(dateString);
        const formattedDate = date.toLocaleString("en-US", 
        {  
            month: "short", 
            day: "numeric"
        });
        return formattedDate;
    },

    getTimeInISTFormat : (dateString) => {
        const date = new Date(dateString);
        const formattedTime = date.toLocaleTimeString('en-US',
        {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });
        return formattedTime;
    },

    isGivenDateGreaterThanCurrent : (inputDate) => {
        const date = new Date();
        if(Number(date.getDate()) > inputDate) {
            return true;
        }
        return false;
    }
}

export default DateUtils;
